"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var validator_1 = require("@formily/validator");
exports.setValidationLanguage = validator_1.setValidationLanguage;
exports.setValidationLocale = validator_1.setValidationLocale;
var shared_1 = require("@formily/shared");
exports.FormPath = shared_1.FormPath;
exports.BigData = shared_1.BigData;
var internals_1 = require("./internals");
var externals_1 = require("./externals");
var graph_1 = require("./shared/graph");
exports.FormGraph = graph_1.FormGraph;
var model_1 = require("./shared/model");
exports.createModel = model_1.createModel;
__export(require("./shared/lifecycle"));
__export(require("./types"));
exports.createForm = function (options) {
    if (options === void 0) { options = {}; }
    return externals_1.createFormExternals(internals_1.createFormInternals(options));
};
exports.registerValidationFormats = validator_1.FormValidator.registerFormats;
exports.registerValidationRules = validator_1.FormValidator.registerRules;
exports.registerValidationMTEngine = validator_1.FormValidator.registerMTEngine;
exports.default = exports.createForm;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/core/lib/index.js
// module id = 118
// module chunks = 0